import React from 'react';
import { FeaturedArticles } from './view/featuredArticles';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'FeaturedArticles', 
  itemElt: (item, cmsOption) => <FeaturedArticles item={item} cmsOption={cmsOption} />
}